import { createReducer, on } from '@ngrx/store';
import { setLoading } from '../actions/loading.actions';

export const initialLoadingState = false;

export const loadingReducer = createReducer(
  initialLoadingState,
  on(setLoading, (state, { isLoading }) => isLoading)
);
